import { render, staticRenderFns } from "./Suosittele.vue?vue&type=template&id=869af134&scoped=true&"
import script from "./Suosittele.vue?vue&type=script&lang=js&"
export * from "./Suosittele.vue?vue&type=script&lang=js&"
import style0 from "./Suosittele.vue?vue&type=style&index=0&id=869af134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869af134",
  null
  
)

export default component.exports